// extracted by mini-css-extract-plugin
export default {"customer-search-box":"SearchWithControls_customer-search-box__M1ie7","search-by-select":"SearchWithControls_search-by-select__n8B+V"};